import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";

//Redux
import { useSelector } from "react-redux";

//Serivce
import ItemService from "../../../services/supplier_appCommonService";

//Components
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import WorkflowApproveReject from "../../../Components/Workflow/WorkflowApproveReject";

const CompanyDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const companyId = location?.state?.companyId || new URLSearchParams(location.search).get("id");
    const documentNumber = location?.state?.documentNumber || new URLSearchParams(location.search).get("documentNumber");

    // Workflow record dispatched from Workflow Inbox (supplier workflow store)
    const workflowRecord = useSelector((state) => state?.supplier?.workflow)?.workflow_record;

    const [getCompanyDetail, setCompanyDetail] = useState({});
    const [getIsPageLoading, setIsPageLoading] = useState(false);

    // Accordion card visibility - one per section (same as RFQ create page)
    const [isCardVisible, setCardVisible] = useState(true);
    const [isCardVisible2, setCardVisible2] = useState(true);
    const [isCardVisible3, setCardVisible3] = useState(true);
    const [isCardVisible4, setCardVisible4] = useState(true);

    const toggleCardVisibility = () => setCardVisible(!isCardVisible);
    const toggleCardVisibility2 = () => setCardVisible2(!isCardVisible2);
    const toggleCardVisibility3 = () => setCardVisible3(!isCardVisible3);
    const toggleCardVisibility4 = () => setCardVisible4(!isCardVisible4);

    useEffect(() => {
        if (companyId) {
            loadCompanyDetail({ _id: companyId });
        } else if (documentNumber) {
            loadCompanyDetail({ documentNumber: documentNumber });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyId, documentNumber]);

    const loadCompanyDetail = async (query) => {
        try {
            setIsPageLoading(true);
            await ItemService.getCompanyDetail(query).then((item) => {
                if (item?.status === 200 && item?.data) {
                    setCompanyDetail(item.data);
                } else {
                    toast.error(item?.message || "!! Unable to Get Company Detail");
                    navigate(Constants.COMPANY_CREATION_LIST);
                }
            });
        } catch (error) {
            console.log("loadCompanyDetail Failed:", error);
            toast.error("!! Unable to Get Company Detail");
        } finally {
            setIsPageLoading(false);
        }
    };

    const handleEdit = () => {
        navigate(Constants.COMPANY_CREATION_UPDATE, { state: { companyId: companyId || d._id } });
    };

    const DetailRow = ({ label, value }) => (
        <Row className="mb-2">
            <Col xs={12} md={5} lg={5}>
                <span className="fw-semibold text-gray-700">{label}</span>
            </Col>
            <Col xs={12} md={7} lg={7}>
                <span className="text-gray-600">{value || "-"}</span>
            </Col>
        </Row>
    );

    const d = getCompanyDetail || {};

    return (
        <main className="dashboard main" id="main">
            <Layout />
            <Row className="justify-center subContent">
                <Col xs={12} md={12} className="rightSide">
                    <div className="rightSideInner PageCommonCSS">
                        <h2 className="mainTitle">Company Details</h2>
                        <p className="subText">
                            {d.documentNumber ? `${d.documentNumber} - ${d.companyName || ""}` : (d.companyCode ? `${d.companyCode} - ${d.companyName || ""}` : "Company Creation and Details")}
                        </p>
                        <hr />

                        {/* Workflow Approve / Reject - only when opened from Workflow Inbox */}
                        {workflowRecord?.businessComponentId === "COMPANY" &&
                            workflowRecord?.businessComponentInstanceId === d.documentNumber && (
                                <WorkflowApproveReject workflowData={{ workflow_record: workflowRecord }} />
                            )}

                        {getIsPageLoading ? (
                            <div className="text-center p-5">Loading...</div>
                        ) : (
                            <React.Fragment>
                                {/* Basic Information */}
                                <div className="accordion mb-4" id="accordionExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <Row className="accordion-button">
                                                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                                                    <i
                                                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"}`}
                                                        onClick={toggleCardVisibility}
                                                    ></i>
                                                </Col>
                                                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                                                    <span className="iconLogo">BI</span>
                                                </Col>
                                                <Col xs={6} md={5} lg={5}>
                                                    <span className="headerTitle">Basic Information</span>
                                                    <span className="subHeaderTitle">
                                                        Company Identity and Classification
                                                    </span>
                                                </Col>
                                                <Col xs={4} md={5} lg={5} className="headerButtonAlign">
                                                    <Col xs={6} md={3} lg={3} className="">
                                                        <button
                                                            className="btnTable"
                                                            onClick={() => navigate(Constants.COMPANY_CREATION_LIST)}
                                                        >
                                                            <i className="bi bi-arrow-left me-2"></i> Back
                                                        </button>
                                                    </Col>
                                                    <Col xs={6} md={3} lg={3} className="">
                                                        <button className="btnTable" onClick={handleEdit}>
                                                            <i className="bi bi-pencil-square me-2"></i> Edit
                                                        </button>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </h2>
                                        <div
                                            className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""}`}
                                        >
                                            <div className="accordion-body">
                                                <Row className="pt-2 pb-4">
                                                    <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                                                        <DetailRow label="Document Number" value={d.documentNumber} />
                                                        <DetailRow label="Company Code" value={d.companyCode} />
                                                        <DetailRow label="Company Name" value={d.companyName} />
                                                        <DetailRow label="Legal Name" value={d.legalName} />
                                                        <DetailRow label="Company Short Name" value={d.companyShortName} />
                                                        <DetailRow
                                                            label="Approval Status"
                                                            value={
                                                                d.approvalStatus ? (
                                                                    <span
                                                                        className={`badge ${d.approvalStatus === "Approved" ? "bg-success" : d.approvalStatus === "Rejected" ? "bg-danger" : "bg-warning text-dark"}`}
                                                                    >
                                                                        {d.approvalStatus}
                                                                    </span>
                                                                ) : (
                                                                    "-"
                                                                )
                                                            }
                                                        />
                                                    </Col>
                                                    <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                                                        <DetailRow label="Company Type" value={d.companyType} />
                                                        <DetailRow label="Registration Number" value={d.registrationNumber} />
                                                        <DetailRow
                                                            label="Company Status"
                                                            value={
                                                                d.companyStatus ? (
                                                                    <span
                                                                        className={`badge ${d.companyStatus === "Active" ? "bg-success" : "bg-danger"}`}
                                                                    >
                                                                        {d.companyStatus}
                                                                    </span>
                                                                ) : (
                                                                    "-"
                                                                )
                                                            }
                                                        />
                                                        <DetailRow label="Company Logo" value={d.companyLogoName || (d.companyLogo ? "Uploaded" : "-")} />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Registered Address & Contact */}
                                <div className="accordion mb-4" id="accordionExample2">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <Row className="accordion-button">
                                                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                                                    <i
                                                        className={`bi ${isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"}`}
                                                        onClick={toggleCardVisibility2}
                                                    ></i>
                                                </Col>
                                                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                                                    <span className="iconLogo">AC</span>
                                                </Col>
                                                <Col xs={8} md={9} lg={9}>
                                                    <span className="headerTitle">Registered Address & Contact</span>
                                                    <span className="subHeaderTitle">
                                                        Address and Contact Information
                                                    </span>
                                                </Col>
                                            </Row>
                                        </h2>
                                        <div
                                            className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""}`}
                                        >
                                            <div className="accordion-body">
                                                <Row className="pt-2 pb-4">
                                                    <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                                                        <DetailRow label="Address Line 1" value={d.addressLine1} />
                                                        <DetailRow label="Address Line 2" value={d.addressLine2} />
                                                        <DetailRow label="Country" value={d.country} />
                                                        <DetailRow label="State" value={d.state} />
                                                        <DetailRow label="City" value={d.city} />
                                                        <DetailRow label="PIN Code" value={d.pinCode} />
                                                    </Col>
                                                    <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                                                        <DetailRow label="Primary Contact Person" value={d.primaryContactPerson} />
                                                        <DetailRow label="Contact Email" value={d.contactEmail} />
                                                        <DetailRow label="Contact Number" value={d.contactNumber} />
                                                        <DetailRow label="Website" value={d.website} />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Tax & Financial Details */}
                                <div className="accordion mb-4" id="accordionExample3">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <Row className="accordion-button">
                                                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                                                    <i
                                                        className={`bi ${isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"}`}
                                                        onClick={toggleCardVisibility3}
                                                    ></i>
                                                </Col>
                                                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                                                    <span className="iconLogo">TF</span>
                                                </Col>
                                                <Col xs={8} md={9} lg={9}>
                                                    <span className="headerTitle">Tax & Financial Details</span>
                                                    <span className="subHeaderTitle">
                                                        PAN, GST & ERP Information
                                                    </span>
                                                </Col>
                                            </Row>
                                        </h2>
                                        <div
                                            className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""}`}
                                        >
                                            <div className="accordion-body">
                                                <Row className="pt-2 pb-4">
                                                    <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                                                        <DetailRow label="PAN" value={d.pan} />
                                                        <DetailRow label="GSTIN" value={d.gstNumber} />
                                                        <DetailRow label="Currency" value={d.currency} />
                                                        <DetailRow label="Financial Year Start" value={d.financialYearStart} />
                                                    </Col>
                                                    <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                                                        <DetailRow label="Financial Year End" value={d.financialYearEnd} />
                                                        <DetailRow label="Accounting Period" value={d.accountingPeriod} />
                                                        <DetailRow label="ERP System" value={d.erpSystem} />
                                                        <DetailRow label="ERP Company/Entity ID" value={d.erpCompanyId} />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Budget Control Settings */}
                                <div className="accordion mb-4" id="accordionExample4">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <Row className="accordion-button">
                                                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                                                    <i
                                                        className={`bi ${isCardVisible4 ? "bi-chevron-right" : "bi-chevron-down"}`}
                                                        onClick={toggleCardVisibility4}
                                                    ></i>
                                                </Col>
                                                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                                                    <span className="iconLogo">BC</span>
                                                </Col>
                                                <Col xs={8} md={9} lg={9}>
                                                    <span className="headerTitle">Budget Control Settings</span>
                                                    <span className="subHeaderTitle">
                                                        Budget Management Configuration
                                                    </span>
                                                </Col>
                                            </Row>
                                        </h2>
                                        <div
                                            className={`accordion-collapse collapse show ${isCardVisible4 ? "visible" : ""}`}
                                        >
                                            <div className="accordion-body">
                                                <Row className="pt-2 pb-4">
                                                    <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                                                        <DetailRow label="Budget Control" value={d.budgetControl} />
                                                        <DetailRow label="Budget Type" value={d.budgetType} />
                                                        <DetailRow label="Budget Control Level" value={d.budgetControlLevel} />
                                                        <DetailRow label="Budget Check Basis" value={d.budgetCheckBasis} />
                                                        <DetailRow label="Budget Exceed Action" value={d.budgetExceedAction} />
                                                    </Col>
                                                    <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                                                        <DetailRow label="Budget Carry Forward" value={d.budgetCarryForward} />
                                                        <DetailRow label="Budget Approval Workflow" value={d.budgetApprovalWorkflow} />
                                                        <DetailRow label="Default Budget Owner" value={d.defaultBudgetOwner} />
                                                        <DetailRow
                                                            label="Budget Tolerance (%)"
                                                            value={d.budgetTolerancePercent !== "" && d.budgetTolerancePercent !== undefined ? d.budgetTolerancePercent : "-"}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </Col>
            </Row>
        </main>
    );
};

export default CompanyDetails;
